import cx from "classnames";
import { forwardRef } from "react";
export const variantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  paragraph: "p",
  body: "p"
};
export const typographyClasses = {
  h1: "text-base font-medium mb-2 md:text-xl ltr:font-heading",
  h2: "text-sm font-medium mb-2 md:text-base",
  h3: "text-sm font-medium mb-2 md:text-base",
  h4: "text-sm font-medium mb-2 md:text-base",
  h5: "text-sm font-medium mb-2 md:text-base",
  h6: "text-sm font-medium mb-2 md:text-base",
  paragraph: "text-sm md:text-base",
  body: "text-sm md:text-base text-[#202529]"
};
const Typography = forwardRef(function Typography(props, ref) {
  const {
    align = "inherit",
    className: classNameProp,
    component,
    gutterBottom = false,
    paragraph = false,
    variant = "body",
    ...other
  } = props;
  const Component = component || (paragraph ? "p" : variantMapping[variant]) || "span";
  const className = cx(typographyClasses[variant], {
    "text-center": align === "center",
    "mb-4": gutterBottom
  }, classNameProp);
  return <Component ref={ref} className={className} {...other} />;
});
export default Typography;